import useSubmitReview from "@/hooks/methodologyReview/useSubmitReview";
import Button from "../shared/ui/Button";
import Modal from "../shared/ui/Modal";

interface IProps {
	isModalOpen: boolean;
	handelModalClose: () => void;
	methodologyRoundId: number;
	canApprove: boolean;
	canReject: boolean;
	status: string;
}

const MethodologyReviewModal = (props: IProps) => {
	const { isModalOpen, methodologyRoundId, handelModalClose, canApprove, canReject, status } = props;

	const { mutate: submitReview } = useSubmitReview();

	const handleStatusChange = (status: string) => {
		submitReview({ status, methodologyRoundId });
		handelModalClose();
	};

	return (
		<Modal title="Approve Or Reject Methodology" isOpen={isModalOpen} closeModal={handelModalClose}>
			<div className="space-y-2">
				{status === "IN_REVIEW" && (
					<p className="mt-6 text-nightSky">
						Please use these questions to decide whether to approve this methodology, conditional on public approval.
					</p>
				)}

				{status === "CONDITIONALLY_APPROVED" && (
					<p className="mt-6 text-nightSky">
						Please use these questions to decide whether to approve this methodology now that public commentary has been
						completed.
					</p>
				)}

				<p>
					<ul className="list-inside list-disc leading-7 text-nightSky">
						<li>
							Does this methodology employ conservative and accurate calculations, grounded in the latest scientific
							data, to ensure that the mitigation from an activity is not overestimated?
						</li>
						<li>
							If a project developer complied with this methodology, would each carbon credit produced by the project
							represent one tonne of CO2e avoided or removed?
						</li>
						<li>If the answer is no, then what prevents this?</li>
					</ul>
				</p>

				{status === "IN_REVIEW" && (
					<>
						<p>
							The rounds will continue until all voting experts have made a decision. Once all experts have approved,
							we'll start a public commentary process, followed by a period where the methodology curator reviews &
							responds to all comments. You'll receive this file for review before you vote for final approval.
						</p>
						<p>
							Please only reject this methodology if you truly believe the premise cannot work and cannot be fixed to
							answer the questions above.
						</p>
					</>
				)}

				{status === "CONDITIONALLY_APPROVED" && (
					<p className="mt-6 text-nightSky">
						Once all experts have made a decision, the final approval or rejection shall be made.
					</p>
				)}

				<div className="flex flex-wrap">
					{canReject && (
						<Button variant="outline" className="mr-4" onClick={() => handleStatusChange("REJECTED")}>
							Reject
						</Button>
					)}
					{canApprove && (
						<Button variant="solid" className="mr-4" onClick={() => handleStatusChange("APPROVED")}>
							Approve Methodology
						</Button>
					)}
				</div>
			</div>
		</Modal>
	);
};

export default MethodologyReviewModal;
